export const scrollToListItem = (containerRef, itemRefs, index) => {
  if (itemRefs.current[index]) {
    const container = containerRef.current;
    const item = itemRefs.current[index];
    container.scrollTop = item.offsetTop - container.offsetTop;
  }
};

/**
 * @function throttle
 * @desc 주어진 시간 간격으로만 함수를 실행하는 유틸리티 함수
 * @param func - 실행할 함수
 * @param limit - 시간 간격
 * @returns {function} - 제한된 함수
 */
export const throttleScroll = (func, limit) => {
  let lastFunc;
  let lastRan;

  return function (...args) {
    const context = this;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(
        () => {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        },
        limit - (Date.now() - lastRan)
      );
    }
  };
};
